import { Routes, Route } from "react-router-dom";
import Login from "../pages/Login/index";
import Register from "../pages/Register/index";
import Dashboard from "../pages/Dashboard/index";
import { useContext } from "react";
import { UserContext } from "../contexts/UserContext";
import { Loading } from "../components/Loading";
import { AnimatePresence } from "framer-motion";

const Router = () => {
  const { loading } = useContext(UserContext);

  return (
    <AnimatePresence>
      {loading ? (
        <Loading />
      ) : (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      )}
    </AnimatePresence>
  );
};

export default Router;
